const INFO = {
	main: {
		title: "North West Wind",
		name: "Michele Maestrale",
		email: "michele.maestrale90@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		// twitter: "https://twitter.com/",
		github: "https://github.com/michele1990",
		linkedin: "https://www.linkedin.com/in/michele-maestrale-3250b681/",
		instagram: "https://www.instagram.com/michelemaestrale/?next=%2F",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "NorthWestWind Digital Solutions",
		description: "<p>NorthWestWind is a single-person entity behind the launch of Swapstamp, a digital loyalty card program expanding in Spain and Italy. At the same time, its core focus stays broader: technology, application development, and digital solutions built with a practical product mindset.</p>",
		description_add: "<p>The project brings together product thinking, software execution, and operational experience. The goal is to design useful digital tools, launch them in the real world, and keep improving them through direct contact with users, partners, and day-to-day business needs.</p>",


	},

	about: {
		title: "NorthWestWind",
		description:
			"<p>Hello. In this picture I was at a Penny Market partner store in Milan after a long day of on-site integration tests. We were having a couple of beers with the team when an issue came up, and that is me handling a live fix from a trash bin while the beers were waiting. It is still one of the most honest snapshots of how I like to work: close to operations, calm under pressure, and focused on solving real problems.</p><p>I care about the satisfaction that comes from well-made things. In larger companies, I enjoy impact, coordination, and the challenge of making complex projects move across teams. In entrepreneurship, I enjoy seeing how tightly connected every function is, from sales to tech, from operations to partnerships, and getting enough exposure to each of them to build a complete profile.</p><p>Recently I have been building <a href=\"https://www.swapstamp.com\" target=\"_blank\" rel=\"noreferrer\">Swapstamp</a> from scratch with a former Glovo colleague as co-founder. The product now has real users, is growing across live market conditions, and is teaching us every day what it really means to scale a digital solution in the real world.</p>",
	},
	

	articles: {
		title: "Articles",
		description:
			"This is where I document product and engineering work, with particular attention to the development of Swapstamp. The focus is on backend architecture, infrastructure decisions, integrations, and the practical challenges of building and operating digital solutions in real conditions.",
	},

	projects: [
		{
			title: "Infrastructure",
			description:
				"Terraform is used as the delivery backbone for the platform, with infrastructure files covering API Gateway, Lambda, DynamoDB, S3, CloudFront, Route53, ACM, Secrets Manager, and supporting analytics resources.",
			logo: "../projects_logo/terraform.png",
			linkText: "View Complete Article",
			link: "/articles",
		},
		{
			title: "Login and Authentication",
			description:
				"The frontend uses AWS Amplify Authenticator with Google as a social provider, while Cognito-backed authorization protects secured API routes and separates access with Customers, Vendors, and Admins groups.",
			logo: "../projects_logo/cognito.png",
			linkText: "View Complete Article",
			link: "/articles",
		},
		{
			title: "Backend",
			description:
				"The application exposes a Lambda-based backend behind API Gateway, mixing public and Cognito-protected endpoints for customer flows, vendor operations, status checks, and wallet-specific entry points.",
			logo: "../projects_logo/awslambda.png",
			linkText: "View Complete Article",
			link: "/articles",
		},
		{
			title: "Vendor Logic",
			description:
				"Swapstamp includes vendor-facing workflows for managing vendor records, defining card types, uploading logos, and redeeming rewards with role-aware checks for owner, admin, manager, and employee permissions.",
			logo: "../projects_logo/swapstamp.svg",
			linkText: "View Complete Article",
			link: "/articles",
		},
		{
			title: "User Logic",
			description:
				"On the customer side, the codebase supports joining loyalty cards, loading a personal dashboard, deleting cards, and persisting simple profile preferences such as language through authenticated endpoints.",
			logo: "../projects_logo/swapstamp.svg",
			linkText: "View Complete Article",
			link: "/articles",
		},
		{
			title: "Apple + Google Wallet Integration",
			description:
				"The wallet layer is split across Apple Wallet pass generation and Apple pass web-service operations, plus Google Wallet object creation and update flows. The setup is already wired into the backend, while some Google Wallet paths are still evolving.",
			logo: "../projects_logo/wallet.png",
			linkText: "View Complete Article",
			link: "/articles",
		},
	],
};

export default INFO;
